export default __webpack_public_path__ + "static/bulb-03-d90dc74a68c39d2bf6c184b47810ef22.svg";